import React, { useState, useEffect, useRef } from "react";

import { getAssets, getAssetTypes, getMenu, getOrderByTypes, getNodeId, getNode } from "./api.js";

// import MenuSection from "./MenuSection.jsx";
import MenuMulti from "./MenuMulti.jsx";
import MenuMobile from "./MenuMobile.jsx";
import Mobile from "./MobileIndex.jsx";
import Filter from "./Filter.jsx";
import AssetItems from "./AssetItems.jsx";
import AssetItemsMobile from "./AssetItemsMobile.jsx";
import Search from "./Search.jsx";
import Listbox from "./Listbox-2.jsx";
import Breadcrumb from "./Breadcrumb.jsx";
import { getPluralForm, ignoreResourceLibraryWord } from "../../../utils/plural"
import MobileContentListbox from "./MobileContentListbox.jsx";

const _history = {
	category: undefined,
	subCategory: undefined,
	subCategoryTwo: undefined,
	subCategoryThree: undefined,
	subCategoryFour: undefined,
	subCategoryFive: undefined,
	subCategorySix: undefined,
	subCategorySeven: undefined,
	subCategoryEight: undefined,
	subCategoryNine: undefined,
	subCategoryTen: undefined,
	path: [],
	node_id: [],
	isAsset: false
};



const urlService = (function () {

	let _root = undefined;

	const _txtAll = 'All';

	// this is a helper function to create the top level menu item for sub menus
	// example, when listing all the Truck children, we'd add a Truck item first to
	// allow a user to select All Truck assets.

	// DZ - MAY NOT NEED THIS ANYLONGER - TRY COMMENT OUT WHEN ALL DONE
	/*	*/
	function createAllMenuItem(item) {

		const name = (ignoreResourceLibraryWord(item.name))
			? item.name
			: getPluralForm(item.name);
		
		return { ...item, children: [], displayName: `${_txtAll} ${name}`, name: item.name };
	}

	// DZ - MAY NOT BE NEEDED ANY LONGER
	/*
	function createEmptyHistoryState() {

		return {
			id: -1,
			parentId: -1,
			path: [],
			node_id: []
		};	
	}
	*/

	function encodeName(name) {

		if (name === undefined || !name.replace)
			return '';

		return name.replace(/\//gi, '')
			.replace(_txtAll, '')
			.trim()
			.replaceAll('-', '_')
			.replaceAll(' ', '-')
			.toLowerCase();
	}

	function decodeName(name) {

		if (name === undefined || !name.replace)
			return '';

		return name
			.replaceAll('-', ' ')
			.replaceAll('_', '-');
    }

	// THIS GETS THE URL AND RETURN SINGLE CATEGORIES - USED WHEN A USER GOES TO A SPECIFIC PAGE IN THE LIBRARY
	function getCategories(path) {

		let categories = [];

		path = window.location.pathname;

		const pathArray = path.split('/');

		// REMOVE LEADING SLASH
		pathArray.shift();

		// REMOVE RESOURCE LIBRARY ITEM
		pathArray.shift();

		for (let i = 0; i < pathArray.length; i++) {
			categories.push(pathArray[i]);
		}

		return categories;
    }

	function init(root) {
		_root = root.replace(/\//g, '').toLowerCase().trim();
	}

	return {

		createAllMenuItem,

		init,

		getCategories,

		encodeName,

		decodeName

	};

})();

//  MAY NOT NEED THIS ANYMORE - TRY COMMENT OUT
/*
function getTitle(item) {
	
	if (!item)
		return '';

	if (ignoreResourceLibraryWord(item.name))
		return item.name;

	if (item.parent?.id === 1)
		return getPluralForm(item.name);

	return item.name;
}
*/


export default (props) => {	
	const [filters, setFilters] = useState([]);
	const [menuPosition, setMenuPosition] = useState(0);
	const [parentMenu, setParentMenu] = useState([]);
	const [activeMenu, setActiveMenu] = useState({ id: -1 });
	const [activeFilters, setActiveFilters] = useState([]);
	const [orderByList, setOrderByList] = useState([]);
	const [orderBy, setOrderBy] = useState({
		description: "File Date",
		value: "FileDate",
	});
	const [firstMenu, setFirstMenu] = useState([]);
	const [secondMenu, setSecondMenu] = useState([]);
	const [thirdMenu, setThirdMenu] = useState([]);
	const [fourthMenu, setFourthMenu] = useState([]);
	const [fifthMenu, setFifthMenu] = useState([]);
	const [sixthMenu, setSixthMenu] = useState([]);
	const [seventhMenu, setSeventhMenu] = useState([]);
	const [eighthMenu, setEighthMenu] = useState([]);
	const [ninethMenu, setNinethMenu] = useState([]);
	const [tenthMenu, setTenthMenu] = useState([]);
	const [mobileArray, setMobileArray] = useState([]);
	const [mobileMenu, setMobileMenu] = useState([]);
	const [tracking, setTracking] = useState(0);
	const [mobileLabels, setMobileLabels] = useState(['All Topics']);
	const [mobileLastClick, setMobileLastClick] = useState();
	const [filterTrigger, setFilterTrigger] = useState(false);
	const [seeAllTrigger, setSeeAllTrigger] = useState(false);
	const [searchTrigger, setSearchTrigger] = useState(false);
	
	/*
	function getResourceFromMenu(menu, predicate) {

		for (let i = 0, l = menu.length; i < l; i++) {
			
			if (predicate(menu[i]))
				return menu[i];

			if (menu[i].children?.length > 0) {

				const resource = getResourceFromMenu(menu[i].children, predicate);

				if (resource !== undefined)
					return resource;
			}
		}

		return undefined;
	}
	*/

	// THIS SETS THE INITIAL STATE OF THINGS - ESPECIALLY WHEN VISITING A SPECIFIC PAGE IN THE LIBRARY
	function setActiveOnload(menu) {
		const categories = urlService.getCategories();
		var tmp_base_category = 'library';
		var tmp_category_parameter = '';
		var tmp_category_one;
		var tmp_category_two;
		var tmp_category_three;

		// THIS IS GROSS BUT IT HAS TO BE NESTED SO THAT IT CHAINS CORRECTLY
		if (categories.length > 0) {
			// START FIRST MENU
			if (categories[0]) {
				tmp_category_one = urlService.decodeName(categories[0]);
				tmp_category_parameter = tmp_base_category + ',' + tmp_category_one;
				getNodeId(tmp_category_parameter).then((id) => {
					getNode(id).then((item) => {
						setParentMenu(item);
						setActiveMenu(item);
						setHistory(item, 'CATEGORY', 'DOWN');
						getMenu(item.id).then((d) => {
							if (d.length >= 1) {
								setSecondMenu(d);
								// START SECOND MENU
								if (categories[1]) {
									tmp_category_two = urlService.decodeName(categories[1]);
									tmp_category_parameter = tmp_category_parameter + ',' + tmp_category_two;
									getNodeId(tmp_category_parameter).then((id) => {
										getNode(id).then((item) => {
											setActiveMenu(item);
											setHistory(item, 'CATEGORY', 'DOWN');
											getMenu(item.id).then((d) => {
												if (d.length >= 1) {
													setThirdMenu(d);
													// START THIRD MENU
													if (categories[2]) {
														tmp_category_three = urlService.decodeName(categories[2]);
														tmp_category_parameter = tmp_category_parameter + ',' + tmp_category_three;
														getNodeId(tmp_category_parameter).then((id) => {
															getNode(id).then((item) => {
																setActiveMenu(item);
																setHistory(item, 'CATEGORY', 'DOWN');
															});
														});
													}
													// END THIRD MENU
												} else {
													_history.isAsset = true;
												}
											});
										});
									});
								}
								// END SECOND MENU
							} else {
								_history.isAsset = true;
							}
						});
					});
				});
			}
			// END FIRST MENU
		}
	}

	/*
	function MenuRenderer() {
		<MenuMulti
			menuItems={secondMenu}
			activeMenuId={activeMenu?.id}
			label="Back to All Topics"
			goBack={() => {
				setSecondMenu([]);
				setActiveMenu({ id: -1 });
				setHistory();
			}}
			onItemClick={(item) => {
				setActiveMenu(item);
				getMenu(item.id).then((d) => {
					if (d.length >= 1) {
						setThirdMenu(d);
					} else {
						_history.isAsset = true;
					}
				});
			}}
		/>
    }
	*/

	// THIS KEEPS TRACK OF WHERE YOU ARE IN THE MENU AND UPDATES THE URL BAR ACCORDINGLY
	function setHistory(item, type, direction) {
		window.scrollTo(0, 0);
		var clean_item_name = '';
		var tmp_history_path = '';
		if (_history.path.length == 0) {
			_history.path.push('brochures-and-videos');
		}
		if (_history.isAsset == true) {
			_history.path.pop();
			_history.node_id.pop();
			_history.isAsset = false;
		}
		if (item) {
			clean_item_name = `${encodeURI(urlService.encodeName(item.name))}`;
			if (type == 'ASSET') {
				if (_history.path.length == 4) {
					_history.path.pop();
					_history.node_id.pop();
				}
				if (direction == 'DOWN') {
					_history.path.push(clean_item_name);
					_history.node_id.push(item);
				} else {
					_history.path.pop();
					_history.node_id.pop();
				}
			} else if (type == 'CATEGORY') {
				if (direction == 'DOWN') {
					_history.path.push(clean_item_name);
					_history.node_id.push(item);
				} else if (direction == 'UP') {
					_history.path.pop();
					_history.node_id.pop();
				}
			}
		} else {
			_history.path.pop();
			_history.node_id.pop();
		}
		tmp_history_path = _history.path.toString();
		tmp_history_path = '/'+ tmp_history_path.replaceAll(',', '/')
		var historyState = {
			path: tmp_history_path
		};
		window.history.pushState(historyState, '', tmp_history_path);


	}

	// THIS SECTION IS THE LISTENER FOR THE BACK AND FORWARD BUTTONS IN THE BROWSER - TBD
	var popEventListnerAdded = false;

	window.onpopstate = function () {
		console.log('Prefire Tracking:' + tracking)
		if (tracking == 0) {
			window.history.back()
		}
		if (tracking == 1) {
			console.log("Tracking Level 1")
			setTracking(tracking - 1);
			setSecondMenu([]);
			setActiveMenu({ id: -1 });
			setHistory(parentMenu, 'CATEGORY', 'UP');
		}
		if (tracking == 2) {
			console.log("Tracking Level 2")
			setTracking(tracking - 1);
			setThirdMenu([]);
			setActiveMenu(parentMenu);
			setHistory(parentMenu, 'CATEGORY', 'UP');
		}
	}

	function breadcrumbHandler(index) {
		if (index != _history.path.length - 1) {
			//WILL NEED TO BE UPDATED TO ACCOUNT FOR EACH INDIVIDUAL LEVEL UNTIL WE MOVE AWAY FROM NAIVE STATIC MENU STRUCTURE
			if (index == 1) {
				setTracking(tracking - 1);
				setThirdMenu([]);
				setActiveMenu(_history.node_id[index]);
				let difference = _history.path.length - index - 1;
				if (difference >= 1) {
					for (let i = 0; i < difference; i++) {
						setHistory();

					}
				}
			}
			else if (index == 0) {
				setTracking(tracking - 1);
				setSecondMenu([]);
				setThirdMenu([]);
				setActiveMenu({ id: -1 });
				for (let i = 0; i < _history.path.length; i++) {
					setHistory(); 
				}
				
			}
		}
	}

	function visibleHandler(searchTerm) {
		if (searchTerm == "") {
			setSearchTrigger(false);
		}
		else setSearchTrigger(true);
	}

	//Mobile Breadcrumb Handler
	function mobileBreadCrumbHandler(index) {
		setMobileArray(mobileArray.slice(0, index));
		setMobileLabels(mobileLabels.slice(0, index+1));
		setMobileMenu(mobileArray[index]);
		setTracking(index);
		setFilterTrigger(false);
		if (index == 0) {
			setActiveMenu({ id: -1 });
		}
	}

	//Search Tile Handler
	function tileHandler(item) {
		if (activeMenu && activeMenu.children && activeMenu.children.length === 0) {
			setHistory();
		}
		else {
			setTracking(tracking + 1);
		}
		setHistory(item, 'CATEGORY', 'DOWN');
		setParentMenu(item);
		setActiveMenu(item);
		getMenu(item.id).then((d) => {
			if (d.length >= 1) {
				setSecondMenu(d);
			} else {
				_history.isAsset = true;
			}
		});
	}

	// THIS USE EFFECT KICKS THE WHOLE THING OFF
	const initialized = useRef(false);

	useEffect(() => {
		if (!initialized.current) {
			initialized.current = true;
			getMenu().then((d) => {
				setFirstMenu(d);
				setMobileMenu(d)
				setActiveOnload(d);
			});

			getOrderByTypes().then((d) => {
				setOrderByList([...d]);
				if (d.length > 0)
					setOrderBy(d[0]);
			});

			getAssetTypes().then((d) => {
				const filters = d.map((filter) =>
					Object.assign(filter, { description: filter.display, value: filter.value }));
				setFilters(filters)
			});
		}

	}, []);

	// CONTROLS THE POSITIONING FOR ANIMATION
	// MAY NEED TO KNOW THE NUMBER OF LEVELS DEEP FOR PRIMARY MENU ITEMS
	useEffect(() => {
		switch (true) {
			case thirdMenu.length > 0:
				setMenuPosition((2 / 3) * 100);
				break;
			case secondMenu.length > 0:
				setMenuPosition((1 / 3) * 100);
				break;
			default:
				setMenuPosition((0 / 3) * 100);
				break;
		}
	}, [thirdMenu.length, secondMenu.length, firstMenu.length]);

	return (
		<div>
			{/*MOBILE*/}
			<div className="tw-max-w-[905px] tw-mx-auto tw-block lg:tw-hidden tw-px-12">
					<section>
						<header>
							<h1 className="mobileHeaderNew tw-text-[33px]">Brochures and Videos</h1>
							<div className="tw-w-full">
								<p className="tw-max-w-[565px] tw-text-[16px]">
									Access the latest product information, videos and images.
								</p>
							</div>
						</header>

					<Search
						{...{
							setSecondMenu,
							setThirdMenu,
							setActiveMenu,
							setUrlPath: setHistory,
							activeFilters,
							visibleHandler,
							menuItems: firstMenu,
							createAllMenuItem: urlService.createAllMenuItem,
							breadCrumb: mobileBreadCrumbHandler
						}}
					/>
										
				</section>
				{filterTrigger && (
					<MobileContentListbox {...{ activeFilters, setActiveFilters, filters }} />
				)}
			</div>
			<div id="mobile" className="tw-block lg:tw-hidden tw-pb-0 tw-pt-0 tw-px-12">

				<div className="tw-flex tw-h-fit tw-w-full tw-transition-transform tw-duration-0" style={{ transform: `translateX(${-menuPosition}%)` }}>
					
					{!searchTrigger && (
					<MenuMobile
						activeMenuName={mobileLabels[tracking]}
						seeAllVisible={seeAllTrigger}
						menuItems={mobileMenu}
						activeMenuId={activeMenu?.id}
						mobileLabels={mobileLabels}
						breadCrumb={mobileBreadCrumbHandler}
						label={`${mobileLabels[tracking - 1] ? 'Back To ' + mobileLabels[tracking - 1] : ''}`}

						setFilterTrigger={setFilterTrigger}

						goBack={() => {
							setMobileMenu(mobileArray[tracking - 1]);
							setMobileArray(mobileArray.slice(0, -1));
							setMobileLabels(mobileLabels.slice(0, -1));
							setTracking((prevTracking) => prevTracking - 1);
							setFilterTrigger(false);
							setSeeAllTrigger(false);
						}}

						seeAll={() => {
							setActiveMenu(mobileLastClick)
							setSeeAllTrigger(false);
						}}

						onItemClick={(item) => {
							
							setActiveMenu(item);
							getMenu(item.id).then((d) => {
								if (d.length >= 1) {
									setMobileArray((prevArray) => [
										...(prevArray || []),
										mobileMenu,
									]);
									setMobileLabels((prevLabels) => [...prevLabels, item.name]);
									setTracking((prevTracking) => prevTracking + 1);
									setMobileMenu(d);
									setMobileLastClick(item);
								} else {
									setFilterTrigger(true);
									setSeeAllTrigger(true);
								}
							});

						}}
					/>
					)}
				</div>

				{filterTrigger && (
					<AssetItemsMobile
						itemLookup={activeMenu?.id}
						itemLookupFn={getAssets}
						activeFilters={activeFilters}
						orderBy={orderBy?.value || ""}
						selectList={orderByList}
						selected={orderBy}
						setSelected={setOrderBy}
					/>
				)}

			</div>
			{/* END DUPLICATE PHYSICAL STRUCTURE OF DESKTOP ON MOBILE */}
			{/* THIS IS NOT NEEDED
			<Breadcrumb history={_history} breadcrumbHandler={breadcrumbHandler} />
			*/}
			<div id="desktop" className="tw-hidden lg:tw-flex lg:tw-flex-row tw-font-sans">
				<div className="tw-bg-accent-gray3 tw-overflow-x-hidden tw-pb-[60px] tw-basis-1/4">
					<div className="tw-flex tw-w-[300%] tw-transition-transform tw-duration-200 tw-mb-[55px]" style={{ transform: `translateX(${-menuPosition}%)` }}>
						{/* FIRST MENU */}
						<MenuMulti
							menuItems={firstMenu}
							activeMenuId={activeMenu?.id}
							onItemClick={(item) => {							
								if (activeMenu && activeMenu.children && activeMenu.children.length === 0) {
									setHistory();
								}
								else {
									setTracking(tracking + 1);
								}
								setHistory(item, 'CATEGORY', 'DOWN');
								setParentMenu(item);
								setActiveMenu(item);
								getMenu(item.id).then((d) => {
									if (d.length >= 1) {
										setSecondMenu(d);
										
										
									} else {
										null
									}
								});
							}}
						/>
						{/* SECOND MENU */}
						<MenuMulti
							menuItems={secondMenu}
							activeMenuId={activeMenu?.id}
							label="Back to All Topics"
							goBack={() => {
								setTracking(tracking - 1);
								setSecondMenu([]);
								setActiveMenu({ id: -1 });
								setHistory(parentMenu, 'CATEGORY', 'UP');
							}}
							onItemClick={(item) => {
								setActiveMenu(item);
								getMenu(item.id).then((d) => {
									if (d.length >= 1) {
										setThirdMenu(d);
										setTracking(tracking + 1);
										setHistory(item, 'CATEGORY', 'DOWN');
									} else {
										null
									}
								});
							}}
						/>
						{/* THIRD MENU */}
						<MenuMulti
							menuItems={thirdMenu}
							activeMenuId={activeMenu?.id}
							// DZ - NEED TO AD LOGIC TO ONLY DO THIS IF THIS IS NOT THE END OF THE MENU
							label={`Back to ${parentMenu?.name}`}
							//label={`Back to ${tertiaryMenu.length ? tertiaryMenu[0].parent?.name : "Sub-topics"}`}
							// DZ - YOU NEED TO ADD IN THE OTHER FUNCTIONS LIKE THE PREVIOUS MENUS
							goBack={() => {
								setTracking(tracking - 1);
								setThirdMenu([]);
								setActiveMenu(parentMenu);
								setHistory(parentMenu,'CATEGORY','UP');
							}}
							onItemClick={(item) => {
								setActiveMenu(item);																
								// NEED TO ADD IN LOGIC TO LOOK FOR CHILDREN IF WE WANT TO EXTEND PASSED THIS LEVEL LIKE THE SECONDARY MENU
							}}
						/>
					</div>
					<Filter {...{ activeFilters, setActiveFilters, filters }} />
				</div>
				<div className="tw-basis-3/4">
					<div className="tw-max-w-[905px] tw-mx-auto">
						<section>
							{activeMenu?.id == -1 ? (
								<header>
									<h1 className="tw-text-[33px]">Brochures and Videos</h1>
									<div className="tw-w-full">
										<p className="tw-max-w-[565px] tw-text-[16px]">
											Access the latest product information, videos and images.
										</p>
									</div>
								</header>
							) : (
								<header className="tw-flex tw-justify-between tw-items-center">
										<h1 className="tw-text-[33px]">{activeMenu.name}</h1>
									<div className="tw-flex-shrink-0">
										<Listbox
											label="Order By"
											selectList={orderByList}
											selected={orderBy}
											setSelected={setOrderBy} />
									</div>
								</header>
							)}
							{activeMenu.id != -1 ? (
								<AssetItems
									itemLookup={activeMenu?.id}
									itemLookupFn={getAssets}
									activeFilters={activeFilters}
									orderBy={orderBy?.value || ""}
								/>
							) : (
								<Search
									{...{
										setSecondMenu,
										setThirdMenu,
										setActiveMenu,
										setUrlPath: setHistory,
										activeFilters,
										tileHandler,
										createAllMenuItem: urlService.createAllMenuItem,
									    menuItems:firstMenu
									}}
								/>
							)}
						</section>
					</div>
				</div>
			</div>
		</div>
	);
};
